import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'hd-http-error',
  templateUrl: './http-error.component.html',
  styleUrls: ['./http-error.component.less']
})
export class HttpErrorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
